import { createIndex } from 'react-instantsearch-core';
var Index = createIndex({
  Root: 'div',
  props: {
    className: 'ais-MultiIndex__root'
  }
});
export default Index;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-instantsearch-dom/dist/es/widgets/Index.js
// module id = 698
// module chunks = 0